import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const InputLabel = ({
    label,
    optional = false,
    required = false,
    fontWeight = 400,
    ...rest
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5
            }}
            {...rest}
        >
            {required && (
                <Typography
                    variant="body2"
                    fontSize={13}
                    sx={{ color: 'error.main' }}
                >
                    *
                </Typography>
            )}

            <Typography
                variant="body2"
                fontSize={13}
                fontWeight={fontWeight}
            >
                {label}
            </Typography>

            {optional && !required && (
                <Typography
                    variant="body2"
                    fontSize={13}
                    color="text.secondary"
                >
                    (optional)
                </Typography>
            )}
        </Box>
    );
};

InputLabel.propTypes = {
    label: PropTypes.string.isRequired,
    optional: PropTypes.bool,
    required: PropTypes.bool,
    fontWeight: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
};

export default InputLabel;